import { useTranslation, Trans } from "react-i18next";
import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { ResponseApiCalls } from "../../apis/ResponseApiCalls";
import GenericModal from "../../components/modals/GenericModal";
import CancelIcon from "../../images/cancel.svg";
import NormalButton from "../../public/buttons/NormalButton";
import PublishModalLeftPane from "./PublishModalLeftPane";
import PublishModalRightPane from "./PublishModalRightPane";
import "./styles.css";

export default function PublishModal({
  pollCode,
  show,
  setModalShow,
  isGenerated,
  handleClickOkay,
  handleClickClose,
  isFromCreating = true
}) {
    const { t } = useTranslation();
  const pollButtonsStyle = {
    float: "right",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "11.6923px",
    paddingTop: "10px",
    paddingBottom: "10px",
    margin: "16px 0px 20px",
  };

  const { uniqueCode } = pollCode;
  const {fakeCall} = ResponseApiCalls();

  useEffect(() => {
    if (show) {
      new Promise((resolve) => {
        fakeCall().then();
        resolve();
      }).then();
    }

  }, [show])

  return (
    <GenericModal
      show={show}
      onHide={handleClickClose}
      content={
        <Container className="center">
          <Row>
            <Col>
              <img
                src={CancelIcon}
                onClick={handleClickClose}
                alt={t("questionBank.optionDeleteAltText")}
                className="publish-modal-close-button cursor-pointer"
              />
            </Col>
          </Row>
          <Row>
            <Col
              style={{
                marginBottom: "0.875rem",
              }}
            >
              {isGenerated ? (
                <span className="publish-modal-title">
                  <Trans
                    i18nKey="questionBuilder.pollCodeGenerated"
                    components={{success: <span style={{ color: "#0a820e" }}/>}}
                  />
                </span>
              ) : (
                <span className="publish-modal-title">{t("questionBuilder.pollCode")}</span>
              )}
            </Col>
          </Row>
          <Row className="publish-modal-subtext-row">
            <Col>
              <span className="publish-modal-subtitle">
                {t("questionBuilder.publishModalDesc")}
              </span>
            </Col>
          </Row>
          <Row>
            <Col style={{ borderRight: "1px solid #C8C8C8" }}>
              <PublishModalLeftPane uniqueCode={uniqueCode} />
            </Col>
            <Col>
              <PublishModalRightPane uniqueCode={uniqueCode} />
            </Col>
          </Row>
          {isFromCreating ?
            (<Row>
              <Col style={{ borderTop: "0.5px solid #C8C8C8" }}>
                <NormalButton style={pollButtonsStyle} onClick={handleClickOkay}>{t("questionBuilder.shareNow")}</NormalButton>
              </Col>
            </Row>) :
            (<Row style={{ height: "3rem" }}>
              <Col className="margin-auto">
              </Col>
            </Row>)}
        </Container>
      }
    />
  );
}
